import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';
import { ClientResolver } from 'core/resolvers/client.resolver';
import { DistributorResolver } from 'core/resolvers';
import { CreditCreateComponent } from './credit-create/credit-create.component';
import { CreditsListComponent } from './credits-list/credits-list.component';
import { BrokerCreditsManagementComponent } from './broker-credits-management/broker-credits-management.component';

const creditsRoutes: Routes = [
  {
    path: 'credits',
    title: 'parentCredits',
    resolve: {},
    children: [
      {
        path: 'new',
        title: 'newCredit',
        component: CreditCreateComponent,
        canActivate: [ProfileGuard],
        data: { action: 'credits.create' },
        resolve: {
          client: ClientResolver
        }
      },
      {
        path: 'clients',
        title: 'creditClients',
        children: [
          {
            path: ':clientId',
            title: 'creditClientId',
            component: CreditsListComponent,
            canActivate: [ProfileGuard],
            resolve: {
              client: ClientResolver
            }
          }
        ]
      },
      {
        path: 'partners',
        children: [
          {
            path: ':distributorId',
            component: BrokerCreditsManagementComponent,
            canActivate: [ProfileGuard],
            resolve: {
              distributor: DistributorResolver
            }
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(creditsRoutes)],
  exports: [RouterModule]
})
export class CreditsRoutingModule {}
